import { ReactNode } from 'react'

import { TableRow } from './Row'

export type TableHeadProps = {
  children?: ReactNode
}

export const TableHead = (props: TableHeadProps) => {
  return (
    <thead>
      <TableRow head>{props.children}</TableRow>
    </thead>
  )
}
